module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Android-10bcb7d492f28d829061fe263e031ee6.svg";